export enum TagsType {
  FOLDERS = "Folders",
  ART = "Art",
  ART_SHORT_LIST = "ArtShortList",
  CART = "Cart",
  OFFER = "Offer",
  MY_BOOKS = "MyBooks",
  SEARCH = "Search",
  COLLECTION = "Collection",
  QUOTE = "Quote",
  REVIEW = "Review",
  USER_MONETIZATION_DATA = "UserMonetizationData",
  REBILLS = "Rebills",
  USER_DETAILED_DATA = "UserDetailedData",
  NOTIFICATIONS = "Notifications",
  USER_REFERRALS = "UserReferrals",
  USER_OPERATIONS = "UserOperations",
  TAG_FACETS = "TagFacets",
  GA_EXTENDS = "GA_EXTENDS",
}
